import { get } from '@/admin/services/api/http-utils';

const url = `${process.env.VUE_APP_API_HOST}admin/customer`;

function fetchCustomer(id) {
  return get(`${url}${id ? `/${id}` : ''}`);
}

export default {
  fetchCustomer,
};
